¸<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="用户userid" prop="userId">
              <a-input v-model="formInline.userId" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item label="商户号" prop="merchantsId">
              <a-input v-model="formInline.merchantsId" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="7">
            <a-form-model-item label="用户uid" prop="uid">
              <a-input v-model="formInline.uid" type="uid" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="4">
            <a-form-model-item label="门店号" prop="shopId">
              <a-input v-model="formInline.shopId" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="日志信息" prop="description">
              <a-input v-model="formInline.description" placeholder="模糊查询">
              </a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="8">
            <a-form-model-item label="下单时间" prop="store">
              <a-range-picker format="YYYY-MM-DD HH:mm:ss" @change="onChange" v-model="formInline.createTime" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <userLogContent
          :formInline="formInline"
          ref="iason"
        ></userLogContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import userLogContent from "./userLogContent.vue";
export default {
  components: {
    userLogContent,
  },
  data() {
    return {
      formInline: {
        userId: "",
        merchantsId: "",
        shopId: "",
        description: "",
        pageNo:1,
        pageSize:10,
      },

    };
  },
  methods: {

    seach(e) {
      this.$refs.iason.pagination = {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      console.log(this.formInline);
      this.$refs.iason.handleOk();
    },
    handleSubmit(e) {
      console.log(this.formInline);
    },
    resetForm() {
      
      this.formInline.merchantsId = "";
      this.formInline.userId = "";
      this.formInline.shopId = "";
      this.formInline.description = "";
      this.$refs.iason.pagination = {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      
      this.$refs.iason.queryData();
    },
    onChange(date, dateString) {
      this.formInline.endTime = dateString[1];
      this.formInline.startTime = dateString[0];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/right/log/userLogHome.vue